// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    ActivateCardRequestModel,
    CardV1CardV1ActivateCardDefaultResponse,
    CardV1CardV1CreateCardDefaultResponse,
    CardV1CardV1CreatePrescriberDefaultResponse,
    CardV1MedBenefitReplaceCardResponse,
    CardV1SmsTextSendResponse,
    CreateCardResponseModel,
    ExtCardActivationResultModel,
    ExtCardReplaceCardAdvancedRequestModel,
    ExtCardReplaceCardResultModel,
    GatewayError,
    IActivateCardRequestModel,
    ICreateCardRequestModel,
    ICreatePrescriberRequestModel,
    IMedBenefitReplaceCardRequestModel,
    ISendCardSmsRequestModel,
    TCApiGatewayControllersCardModelsCardProgramRequestModel,
    TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel,
    TCApiGatewayControllersCardModelsSendCardSmsRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeCardApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsCardProgramRequestModel 
     */
    public async cardActivateCard (xProgramId?: string, tCApiGatewayControllersCardModelsCardProgramRequestModel?: TCApiGatewayControllersCardModelsCardProgramRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/activateCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsCardProgramRequestModel, "TCApiGatewayControllersCardModelsCardProgramRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param iActivateCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV1ActivateCard (iActivateCardRequestModel: IActivateCardRequestModel, xProgramId?: string): Promise<AxiosResponse<CardV1CardV1ActivateCardDefaultResponse>> {
        const _url_ = '/edge/card/v1/ActivateCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iActivateCardRequestModel' is not null or undefined
        if (iActivateCardRequestModel === null || iActivateCardRequestModel === undefined) {
            throw new Error('Required parameter iActivateCardRequestModel was null or undefined when calling cardV1ActivateCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iActivateCardRequestModel, "IActivateCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CardV1CardV1ActivateCardDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1CardV1ActivateCardDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iCreateCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV1CreateCard (iCreateCardRequestModel: ICreateCardRequestModel, xProgramId?: string): Promise<AxiosResponse<CardV1CardV1CreateCardDefaultResponse>> {
        const _url_ = '/edge/card/v1/CreateCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iCreateCardRequestModel' is not null or undefined
        if (iCreateCardRequestModel === null || iCreateCardRequestModel === undefined) {
            throw new Error('Required parameter iCreateCardRequestModel was null or undefined when calling cardV1CreateCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iCreateCardRequestModel, "ICreateCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CardV1CardV1CreateCardDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1CardV1CreateCardDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iCreatePrescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV1CreatePrescriber (iCreatePrescriberRequestModel: ICreatePrescriberRequestModel, xProgramId?: string): Promise<AxiosResponse<CardV1CardV1CreatePrescriberDefaultResponse>> {
        const _url_ = '/edge/card/v1/CreatePrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iCreatePrescriberRequestModel' is not null or undefined
        if (iCreatePrescriberRequestModel === null || iCreatePrescriberRequestModel === undefined) {
            throw new Error('Required parameter iCreatePrescriberRequestModel was null or undefined when calling cardV1CreatePrescriber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iCreatePrescriberRequestModel, "ICreatePrescriberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CardV1CardV1CreatePrescriberDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1CardV1CreatePrescriberDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param activateCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV2ActivateCard (activateCardRequestModel: ActivateCardRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtCardActivationResultModel>> {
        const _url_ = '/edge/card/v2/Card/activateCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'activateCardRequestModel' is not null or undefined
        if (activateCardRequestModel === null || activateCardRequestModel === undefined) {
            throw new Error('Required parameter activateCardRequestModel was null or undefined when calling cardV2ActivateCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(activateCardRequestModel, "ActivateCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtCardActivationResultModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtCardActivationResultModel");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV2CreateCard (xProgramId?: string): Promise<AxiosResponse<CreateCardResponseModel>> {
        const _url_ = '/edge/card/v2/Card/createCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CreateCardResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CreateCardResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param extCardReplaceCardAdvancedRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardV2ReplaceCardAdvanced (extCardReplaceCardAdvancedRequestModel: ExtCardReplaceCardAdvancedRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtCardReplaceCardResultModel>> {
        const _url_ = '/edge/card/v2/Card/replaceCardAdvanced';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extCardReplaceCardAdvancedRequestModel' is not null or undefined
        if (extCardReplaceCardAdvancedRequestModel === null || extCardReplaceCardAdvancedRequestModel === undefined) {
            throw new Error('Required parameter extCardReplaceCardAdvancedRequestModel was null or undefined when calling cardV2ReplaceCardAdvanced.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extCardReplaceCardAdvancedRequestModel, "ExtCardReplaceCardAdvancedRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtCardReplaceCardResultModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtCardReplaceCardResultModel");
        }
        return response;
    }
    /**
     * 
     * @param iMedBenefitReplaceCardRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medBenefitReplaceCard (iMedBenefitReplaceCardRequestModel: IMedBenefitReplaceCardRequestModel, xProgramId?: string): Promise<AxiosResponse<CardV1MedBenefitReplaceCardResponse>> {
        const _url_ = '/edge/card/v1/MedBenefit/ReplaceCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iMedBenefitReplaceCardRequestModel' is not null or undefined
        if (iMedBenefitReplaceCardRequestModel === null || iMedBenefitReplaceCardRequestModel === undefined) {
            throw new Error('Required parameter iMedBenefitReplaceCardRequestModel was null or undefined when calling medBenefitReplaceCard.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iMedBenefitReplaceCardRequestModel, "IMedBenefitReplaceCardRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CardV1MedBenefitReplaceCardResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1MedBenefitReplaceCardResponse");
        }
        return response;
    }
    /**
     * 
     * @param iSendCardSmsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async smsTextSend (iSendCardSmsRequestModel: ISendCardSmsRequestModel, xProgramId?: string): Promise<AxiosResponse<CardV1SmsTextSendResponse>> {
        const _url_ = '/edge/card/v1/SmsText/Send';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iSendCardSmsRequestModel' is not null or undefined
        if (iSendCardSmsRequestModel === null || iSendCardSmsRequestModel === undefined) {
            throw new Error('Required parameter iSendCardSmsRequestModel was null or undefined when calling smsTextSend.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iSendCardSmsRequestModel, "ISendCardSmsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<CardV1SmsTextSendResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CardV1SmsTextSendResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsSendCardSmsRequestModel 
     */
    public async smsTextSend_1 (xProgramId?: string, tCApiGatewayControllersCardModelsSendCardSmsRequestModel?: TCApiGatewayControllersCardModelsSendCardSmsRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/smsText/Send';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsSendCardSmsRequestModel, "TCApiGatewayControllersCardModelsSendCardSmsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersCardModelsExtCardReplaceCardResultModel 
     */
    public async v2ReplaceCard (xProgramId?: string, tCApiGatewayControllersCardModelsExtCardReplaceCardResultModel?: TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Card/v2/replaceCard';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersCardModelsExtCardReplaceCardResultModel, "TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
}
